module.exports = __webpack_public_path__ + "static/promo-text-1-40825329522dad72128a737eeae2ed13.svg";